import {memo, useContext, useMemo} from 'react'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {useIsAutodetectTimeZone} from '../../../../../hooks/useIsAutodetectTimeZone'
import {getBuild} from '../../../../../selectors'
import type {BuildId} from '../../../../../types'
import {displayDate} from '../../../../../utils/dateTimeUtils'
import BuildBranch from '../../../../common/BranchLabel/BuildBranchLabel.container'
import BuildNumber from '../../../../common/BuildNumber/BuildNumber.container'
import BuildStatus from '../../../../common/BuildStatus/BuildStatus.container'
import Details from '../../../../common/Details/Details'
import {ChangesGraphIndentContext} from '../../Change/Change.context'

import styles from './Build.css'

type Props = {
  className?: string
  buildId: BuildId
}

function Build({buildId}: Props) {
  const changesGraphIndent = useContext(ChangesGraphIndentContext)
  const number = useAppSelector(state => getBuild(state, buildId)?.number)
  const startDate = useAppSelector(state => getBuild(state, buildId)?.startDate)
  const isAutodetectTimeZone = useIsAutodetectTimeZone()

  const renderRow = useMemo(
    () => (
      <div className={styles.build}>
        <div className={styles.row}>
          <div className={styles.column}>
            <div
              className={styles.columnContent}
              style={changesGraphIndent !== 0 ? {paddingLeft: `${changesGraphIndent}px`} : {}}
            >
              <BuildBranch className={styles.branch} buildId={buildId} />
              <BuildNumber className={styles.number} buildId={buildId} hideStar />
              <BuildStatus className={styles.status} buildId={buildId} />
              {startDate != null && (
                <span className={styles.startDate}>
                  {displayDate(startDate, isAutodetectTimeZone, true)}
                </span>
              )}
            </div>
          </div>
        </div>
        <div />
      </div>
    ),
    [buildId, changesGraphIndent, isAutodetectTimeZone, startDate],
  )

  return (
    <div className={styles.item}>
      <div className={styles.psevdoItem} data-graph-id={`tr-build-${buildId}`} />
      <Details
        headingClassName={styles.detailsHeading}
        level={2}
        label={`Build ${number}`}
        summary={renderRow}
        summaryClassName={styles.button}
        imitateHeading
        renderButtonAside
      />
    </div>
  )
}

export default memo(Build)
